import {useLocation} from '@github-ui/react-router'
import {createContext, use, useEffect} from 'react'
import {usePrefersReducedMotion} from '@github-ui/use-prefers-reduced-motion'

export const FocusHashTargetGuardContext = createContext<() => boolean>(() => true)

/**
 * Scroll to and focus the target element when matched by the URL hash.
 * The element with the matching ID must be focusable.
 */
export function useFocusHashTarget(id: string) {
  const {hash, key} = useLocation()
  const prefersReducedMotion = usePrefersReducedMotion()
  const shouldFocus = use(FocusHashTargetGuardContext)
  const targetId = hash.slice(1) // remove leading #
  const isHashTarget = id === targetId

  useEffect(() => {
    if (isHashTarget && shouldFocus()) {
      const element = document.getElementById(id)
      if (!element) return

      element.scrollIntoView({block: 'center', behavior: prefersReducedMotion ? 'auto' : 'smooth'})
      element.focus({
        focusVisible: true,
        preventScroll: true,
      })
    }
  }, [id, isHashTarget, key, prefersReducedMotion, shouldFocus])

  return isHashTarget
}
